import axios from 'axios';
import {getConfig} from "../config";
import {ProjectOption} from "../types/ProjectOption";


const AUTH_TOKEN = 'VdjCKidks7qTEyuU6QeJtezZ3PeCHhZQ2yHJ3kPtcfTN8BjVqU';
const { API_BASE_URL } = getConfig();
class ApiService {
    private static projectOptions: ProjectOption[] | null = null;

    static async fetchProjectOptions(): Promise<ProjectOption[]> {
        if (this.projectOptions) {
            return this.projectOptions;
        }
        try {
            const response = await axios.get<ProjectOption[]>(
                `${API_BASE_URL}/getNetworkPlanExistingProjects?auth=${AUTH_TOKEN}`
            );
            this.projectOptions = response.data;
            return response.data;
        } catch (error) {
            console.error('Error fetching project options:', error);
            throw new Error('Unable to fetch project options.');
        }
    }
}

export default ApiService;
